import { WebdoorList } from '../models/webdoor'

import bannerDesktop1 from '../assets/banners/lendas-colecionaveis.png'
import bannerTablet1 from '../assets/banners/lendas-colecionaveis_768.png'
import bannerMobile1 from '../assets/banners/lendas-colecionaveis_375.png'

import bannerDesktop2 from '../assets/banners/gp-sp2025.png'
import bannerTablet2 from '../assets/banners/gp-sp2025_768.png'
import bannerMobile2 from '../assets/banners/gp-sp2025_375.png'

import bannerDesktop3 from '../assets/banners/tanque-cheio-de-premios.png'
import bannerTablet3 from '../assets/banners/tanque-cheio-de-premios_768.png'
import bannerMobile3 from '../assets/banners/tanque-cheio-de-premios_375.png'

export const getWebdoors = async (): Promise<WebdoorList> => {
  return Promise.resolve([
    {
        id: '1',
        title: 'Shell & Scuderia Ferrari HP Lendas colecionáveis',
        link: 'https://promo.shell.com.br/colecionaveis/',
        images: {
            desktop: bannerDesktop1,
            tablet: bannerTablet1,
            mobile: bannerMobile1,
        },
    }, {
        id: '2',
        title: 'V-iva a emoção das pistas no Grande Prêmio de SP 2025',
        link: 'https://promo.shell.com.br/experiencias/',
        images: {
            desktop: bannerDesktop2,
            tablet: bannerTablet2,
            mobile: bannerMobile2,
        },
    }, {
        id: '3',
        title: 'Tanque cheio de Prêmios',
        link: 'https://promo.shell.com.br/etanol/',
        images: {
            desktop: bannerDesktop3,
            tablet: bannerTablet3, 
            mobile: bannerMobile3, 
        },
    },
  ])
}


